import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

import type { SpaceViewsPersistenceOption } from './__generated__/useSpaceViewsOptionsPersistenceQuery.graphql.ts';

export const fireItemClickedAnalytics =
	(
		createAnalyticsEvent: CreateUIAnalyticsEvent,
		spaceViewsSort: SpaceViewsPersistenceOption,
		contentTreeSize: number | undefined,
	) =>
	(id: string): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'pageTree',
				source: 'pageTree',
				objectId: id,
				attributes: {
					spaceView: spaceViewsSort,
					navdexPointType: START_TOUCH,
					contentTreeSize,
				},
			},
		}).fire();
	};

export const fireSpaceViewsOptionClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, selection: any) =>
	(option: any): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: option,
				source: 'spaceViewsMenu',
				attributes: {
					spaceView: selection,
				},
			},
		}).fire();
	};

export const fireSpaceViewsTriggerClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, selection: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'spaceViews',
				source: 'spaceViewsMenu',
				attributes: {
					spaceView: selection,
				},
			},
		}).fire();
	};
